import { useSelector, useDispatch } from "react-redux";

/**@reduxActions */
import {
    togglePopup,
    toggleMobileExplore,
} from "../../store/features/modalSlice";

/**@Icons */
import { MdOutlineKeyboardArrowRight } from "react-icons/md";
import { IoMdArrowDropdown, IoMdArrowDropup } from "react-icons/io";

export default function Explore() {
    const dispatch = useDispatch();
    const { openMobileExplore } = useSelector((state) => state.modal);

    const startOptions = [
        {
            name: "Celebrations",
            filterKey: "eventTypes",
            subKey: [
                "Weddings",
                "Weddings",
                "Dining",
                "Dining",
                "Dining",
                "Dining",
                "Milestone Birthdays",
                "Tea Party/Showers",
                "Tea Party/Showers",
                "Teen/Children",
                "Special Big Events",
            ],
            subOptions: [
                "Wedding Ceremony",
                "Wedding Reception",
                "Anniversary Party",
                "Engagement Reception",
                "Graduation Party",
                "New Year's Eve Party",
                "Birthday Party",
                "Baby Shower",
                "Bridal Shower",
                "Teen Party",
                "Gender Reveals",
                "Christmas Party",
                "Cultural Celebrations",
            ],
        },
        {
            name: "Art & Culture",
            filterKey: "eventTypes",
            subKey: [
                "Filming, Photography & Media",
                "Art Spaces",
                "Art Spaces",
                "Performances & Exhibitions",
                "Performances & Exhibitions",
                "Performances & Exhibitions",
            ],
            subOptions: [
                "Photoshoot",
                "Art Exhibitions",
                "Pop Up Event",
                "Concert",
                "Fashion Show",
                "Live Performance",
            ],
        },
        {
            name: "Corporate",
            filterKey: "eventTypes",
            subKey: [
                "Conference/Seminars",
                "Conference/Seminars",
                "Conference/Seminars",
                "Conference/Seminars",
                "Conference/Seminars",
                "Corporate Events",
                "Conference/Seminars",
                "Corporate Events",
                "Corporate Events",
                "Corporate Events",
            ],
            subOptions: [
                "Conference",
                "Exhibitions",
                "Meetings",
                "Networking",
                "Product Launch",
                "Team Building",
                "Training",
                "Office Party",
                "Corporate Gala Dinner",
                "Corporate Retreat",
            ],
        },
        {
            name: "City",
            filterKey: "city",
            subOptions: [
                "Dubai",
                "Abu Dhabi",
                "Ras Al Khaimah",
                "Sharjah",
                "Fujairah",
                "Ajman",
                "Umm Al Quwain",
            ],
        },
        {
            name: "Venue Type",
            filterKey: "venueTypes",
            subOptions: [
                "Beach",
                "Deserts",
                "Boats and Yachts",
                "Venue with Onsite Activities",
                "Sports Venue",
                "Exhibition Hall",
                "Meeting room",
                "Kids play area",
                "Restaurant",
                "Ballroom",
                "Blank Canvas",
                "Auditorium",
                "Warehouse",
                "Indoor",
                "Outdoor",
                "Indoor & Outdoor",
            ],
        },
        {
            name: "Hotel Stay + Venue",
            filterKey: "hotelStayAndVenue",
            subOptions: [
                "Airport Hotel",
                "All-Inclusive Resort",
                "Beach Hotel",
                "Boutique Hotel",
                "Budget Hotel",
                "Business Hotel",
                "Casino Hotel",
                "City Hotel",
                "Desert Hotel",
                "Eco-friendly Hotel",
                "Floating Hotel",
                "Glamping Hotel",
                "Golf Resorts",
                "Heritage Hotel",
                "Historic Hotel",
                "Island Hotel",
                "Luxury Hotel",
                "Resort Hotel",
                "Safari Hotel",
                "Wellness Hotel",
            ],
        },
    ];

    return (
        <>
            <div
                onClick={() => dispatch(toggleMobileExplore())}
                className="z-40 text-[16px] font-bold flex justify-between items-center w-full"
            >
                <p>Explore</p>
                {openMobileExplore ? (
                    <IoMdArrowDropup className="text-2xl" />
                ) : (
                    <IoMdArrowDropdown className="text-2xl" />
                )}
            </div>
            {openMobileExplore && (
                <div className="flex text-xl flex-col gap-8 pl-6">
                    {startOptions.map((e, i) => (
                        <div
                            key={i}
                            className="flex justify-between text-[16px] text-[#FE4747] font-medium items-center cursor-pointer"
                            onClick={() =>
                                dispatch(
                                    togglePopup({
                                        isOpen: true,
                                        subOptions: e.subOptions,
                                        name: e.name,
                                        filterKey: e.filterKey,
                                        selectedOption: e,
                                    })
                                )
                            }
                        >
                            {e.name}
                            <MdOutlineKeyboardArrowRight className="text-2xl flex-shrink-0" />
                        </div>
                    ))}
                </div>
            )}
        </>
    );
}
